import axios from "../../utils/axios";

export const getRelatedPosts = async ({ tags, postId }) => {
    let queryString =
        tags?.length > 0
            ? tags.map((tag) => `tags_like=${tag}`).join("&") +
              `&id_ne=${postId}`
            : `id_ne=${postId}`;

    const response = await axios.get(`/blogs?${queryString}`);

    return response.data;
};
